/**
 * DeleteJobModal
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';
import { AppState } from 'services/types';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

// Actions
import { updateQueryString } from '../../../../../../services/router/actions';

// Components
// @ts-ignore
import ErrorBoundaryAlert from '../../../../../../components/ErrorBoundaryAlert';
import RoleGate from '../../../../../../components/RoleGate';
// @ts-ignore
import DocumentSetEventSchemaName from '../../../../components/DocumentSetEventSchemaName';
// @ts-ignore
import DocumentSetEventEntityHierarchy from '../../../../components/DocumentSetEventEntityHierarchy';
import DeleteJobForm from './components/DeleteJobForm';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from '../../../../../../workspaces/redux-error-boundary';
import {
    makeSelectQueryStringValue,
    makeSelectQueryStringNumberValue
} from '../../../../../../workspaces/react-router-selectors';

interface ConnectedProps {
    selectedJobId: number;
    deleteJobModal: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps;

export class DeleteJobModal extends React.PureComponent<Props> {
    get open(): boolean {
        const { deleteJobModal, selectedJobId } = this.props;
        return !!deleteJobModal && !!selectedJobId;
    }

    handleClose = (): void => {
        this.props.updateQueryString({
            deleteJobModal: undefined,
            selectedJobId: undefined
        });
    };

    render(): React.ReactElement {
        const { selectedJobId } = this.props;

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={this.open}
                    onClose={this.handleClose}
                    size="tiny"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="DeleteJobDialog"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>
                            {'Delete '}
                            <DocumentSetEventSchemaName
                                documentSetId={selectedJobId}
                            />
                        </Modal.Header>
                        <Modal.Content>
                            <p>
                                {'Are you sure you want to delete this job on '}
                                <DocumentSetEventEntityHierarchy
                                    documentSetId={selectedJobId}
                                />
                                ?
                            </p>
                            <DeleteJobForm
                                documentSetId={selectedJobId}
                                onClose={this.handleClose}
                            />
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    selectedJobId: makeSelectQueryStringNumberValue('selectedJobId'),
    deleteJobModal: makeSelectQueryStringValue('deleteJobModal')
});

export default connect(mapStateToProps, { updateQueryString })(DeleteJobModal);
